<template>
    <div class="library-item" @click.stop="toDetails(item)">
        <h3>{{ item.newsTitle }}</h3>
        <p>{{ item.brief }}</p>
        <div class="line"></div>
        <div class="author-info">
            <img v-if="item.authorAvatar" :src="item.authorAvatar" alt="">
            <img v-else src="@/assets/images/default-avatar.png" alt="">
            <span>{{ item.author }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LibraryItem',
    props: {
        item: {
            type: Object,
            required: true
        },
    },
    methods: {
        toDetails(item) {
            localStorage.setItem('newsId', item.newsId);
            let path = item.seoUrl ? item.seoUrl : item.newsId
            this.$router.push({
                path: `/${path}.html`,
            });
        },
        generateSlug(title) {
            // 将标题中的空格替换为连字符
            let slug = title.toLowerCase().replace(/\s+/g, '-');
            // 将连字符替换为单个连字符
            slug = slug.replace(/-+/g, '');
            slug = slug.replace(/:+/g, '');
            return slug;
        },
    }
}
</script>

<style lang="less" scoped>
.library-item {
    width: 100%;
    background: #FFFFFF;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 20px;
    cursor: pointer;
    border: 2px solid transparent;

    h3 {
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        font-size: 18px;
        color: #2C2C2E;
        line-height: 24px;
        text-align: left;
        font-style: normal;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
    }

    p {
        font-family: MicrosoftYaHei;
        font-size: 14px;
        color: #636366;
        line-height: 19px;
        text-align: justify;
        font-style: normal;
        margin-top: 6px;
    }

    .line {
        width: 100%;
        height: 1px;
        background: #F2F2F7;
        margin: 16px 0 12px 0;
    }

    .author-info {
        display: flex;
        align-items: center;

        img {
            width: 36px;
            height: 36px;
            object-fit: cover;
            border-radius: 50%;
            margin-right: 8px;
        }

        span {
            font-family: MicrosoftYaHei;
            font-size: 14px;
            color: #2C2C2E;
            line-height: 19px;
            text-align: left;
            font-style: normal;
        }
    }

    &:hover {
        border-color: #E2291E;
    }
}

// .library-item:nth-child(6n) {
//     margin-bottom: 0;
// }</style>



// WEBPACK FOOTER //
// src/views/common/library-item.vue